import Vue from "vue"
import App from "./App.vue"

import "bootstrap/dist/css/bootstrap.min.css"

import { config } from "./config.js";
import { utils } from "./utils.js";
import { mediaAlphaUtils } from "./mediaAlphaUtils.js";
import { visiquaUtils } from "./visiquaUtils.js";

// axios
import axios from "axios"

axios.defaults.baseURL = config.apiUrl;
axios.defaults.timeout = config.timeout;
axios.defaults.headers.post["Accept"] = "application/json";
axios.defaults.headers.post["Content-Type"] = "application/json";

// configure stuff
Vue.config.productionTip = false;
Vue.prototype.axios = axios;
Vue.prototype.appConfig = config;
Vue.prototype.utils = utils;
Vue.prototype.mediaAlphaUtils = mediaAlphaUtils;
Vue.prototype.visiquaUtils = visiquaUtils;
Vue.prototype.AvengeDigitalWidgetYearMakeModelTrims = window.AvengeDigitalWidgetYearMakeModelTrims;

// router
import VueRouter from "vue-router";
Vue.use(VueRouter);

import stepSelector from "./stepSelector.js";

const routes = [
    {
        path: "/:type/:step",
        component: stepSelector,
        props: true
    },
    {
        path: "/Auto",
        redirect: "/Auto/VehicleYear"
    },
    {
        path: "/Home",
        redirect: "/Home/HomeType"
    },
    {
        path: "/",
        redirect: config.redirectPath
    },
    {
        path: "",
        redirect: config.redirectPath
    }
];

const router = new VueRouter({
    routes
});

// google analytics
import VueGtag from "vue-gtag";

if (config.googleAnalyticsTrackingId) {
    Vue.use(VueGtag, {
        config: { id: config.googleAnalyticsTrackingId }
    }, router);
}

new Vue({
  router,
  render: h => h(App),
}).$mount("#app")
